/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AuthContext from './Provider';
// import store from '../../reducers';
import * as utils from './utils';
import * as constants from '../../utils/constants';
// import User from '../../domain/User';
import { doGet } from '../../utils/requests';

class AuthenticationProvider extends Component {
  constructor() {
    super();

    const jwt = utils.getJwt();

    if (jwt) {
      const time = new Date();
      time.setSeconds(utils.getParameterByName('expires_in'));
      const ttl = time;

      this.state = {
        ttl,
        userData: this.setUserFromDataFromJwt(jwt),
        jwt,
        authVerified: true,
      };

      return;
    }

    const token = utils.getParameterByName('access_token');
    this.state = this.getInitialState();
    if (token) {
      this.state.authVerified = false;
      this.requestJwt(token, this.handleUserDataChange, this.handleErrorRequestJwt);

      const { comprevBaseUrl } = window.comprevConfig;
      window.history.replaceState(null, null, comprevBaseUrl);
    }
  }

  getInitialState() {
    return {
      authVerified: true,
      ttl: null,
      jwt: null,
      userData: null,
      token: null,
      entesControlados: [],
      codigoParticipante: null,
    };
  }

  componentDidUpdate() {
    if (this.state.authVerified && this.state.userData && new Date() >= this.state.userData.exp * 1000) {
      // eslint-disable-next-line no-alert
      alert('Sessão expirada.');
      const { comprevBaseUrl } = window.comprevConfig;
      this.state = this.getInitialState();
      this.state.authVerified = false;
      utils.logout();
      window.open(`${comprevBaseUrl}`, '_self');
    } else if (this.state.authVerified && this.state.userData && new Date() < this.state.userData.exp * 1000) {
      if (sessionStorage.getItem('comprevConfigLogotipo')) {
        const exibirLogo = JSON.parse(sessionStorage.getItem('comprevConfigLogotipo'));
        if (exibirLogo.exibirLogo === 1) {
          sessionStorage.setItem('comprevConfigLogotipo', JSON.stringify({ exibirLogo: 0 }));
          window.comprevConfigLogotipo = { exibirLogo: 0 };
        }
      }
    }
  }

  setUserFromDataFromJwt = jwt => (
    JSON.parse(window.atob(jwt.split('.')[1]))
  )

  requestJwt = (token, callback, failback) => {
    const { comprevNewdooUrl } = window.comprevConfig;

    const parametrosGerid = [
      ['access_token', token],
      ['modulo', 'INSS'],
      ['modulo', 'DATAPREV'],
      ['modulo', 'MPS'],
      ['modulo', 'CNPJ'],
      ['includeGranterOu', 'true'],
    ].map(e => `${e[0]}=${e[1]}`).join('&');

    const URL = `${comprevNewdooUrl}/apis/cas/jwt?${parametrosGerid}`;
    // eslint-disable-next-line no-console
    doGet(URL, r => callback(r.data), failback);
  };

  handleUserDataChange = (jwt) => {
    utils.storeJwt(jwt);
    this.setState({
      authVerified: true,
      userData: this.setUserFromDataFromJwt(jwt),
    });

    // if (User.logged().isRPPS()) {
    //  solicitarParticipante(User.logged().cnpjDoPapel(), this.handleCodigoDoParticipante);
    // }
  }

  // handleCodigoDoParticipante = (r) => {
  //  solicitarEntesControlados(r.data.codigo, this.handleEntesControlados);
  // }

  // handleEntesControlados = (e) => {
  //  store.dispatch({ type: 'SALVA_ENTES_CONTROLADOS', payload: e.data });
  // }

  handleErrorRequestJwt = () => {
    this.setState({ authVerified: true });
  }

  checkPermission = (allowedPermissions) => {
    const permissions = constants.getPermissions(allowedPermissions);
    if (this.state.userData) {
      const userPermissions = [];
      this.state.userData.roles.forEach((role) => {
        const roleMatch = role.match(/PA\|(.*?)\|/g);
        if (roleMatch) {
          userPermissions.push(roleMatch.map(permission => permission.split('|')[1])[0]);
        }
      });
      return permissions.some(allowedPermission =>
        userPermissions.includes(allowedPermission));
    }
    return false;
  }

  render() {
    if (this.state.authVerified) {
      return (
        <AuthContext.Provider
          value={{
          changeUser: this.handleUserDataChange,
          checkPermission: this.checkPermission,
          jwt: this.state.jwt,
          userData: this.state.userData,
        }}
        >
          {this.props.children}
        </AuthContext.Provider>
      );
    }
    return null;
  }
}

AuthenticationProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
};

export default AuthenticationProvider;



// WEBPACK FOOTER //
// ./src/components/ComponentesAutenticacao/AuthenticationProvider.jsx